import { createFileRoute, redirect } from "@tanstack/react-router";

import { KeybindingsSettingsPanel } from "../components/settings/KeybindingsSettings";
import { isElectron } from "../env";

export const Route = createFileRoute("/settings/keybindings")({
  // The desktop alone edits shortcuts. A browser keeps most of the defaults to
  // itself (new window, tab switching), and a team server's keybindings file is
  // one for the whole team, so an edit there would change every member's.
  beforeLoad: () => {
    if (!isElectron) {
      throw redirect({ to: "/settings/general", replace: true });
    }
  },
  component: KeybindingsSettingsPanel,
});
